import { render, staticRenderFns } from "./cDocumentDataTable.vue?vue&type=template&id=6de9bb48&scoped=true"
import script from "./cDocumentDataTable.vue?vue&type=script&lang=js"
export * from "./cDocumentDataTable.vue?vue&type=script&lang=js"
import style0 from "./cDocumentDataTable.vue?vue&type=style&index=0&id=6de9bb48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de9bb48",
  null
  
)

export default component.exports